function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Row, Col } from '../grid';
var prefixCls = 'eui-layout';

var Layout = /*#__PURE__*/function (_React$Component) {
  _inherits(Layout, _React$Component);

  var _super = _createSuper(Layout);

  function Layout() {
    var _this;

    _classCallCheck(this, Layout);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      var _this$props = _this.props,
          open = _this$props.open,
          onToggle = _this$props.onToggle;

      if (open) {
        onToggle(false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function (e) {
      var _this$props2 = _this.props,
          open = _this$props2.open,
          onToggle = _this$props2.onToggle;
      e.stopPropagation();
      onToggle(!open);
    });

    return _this;
  }

  _createClass(Layout, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        layout: this
      };
    }
  }, {
    key: "render",

    /*
    state = {
      siders: [],
      siderCollapsed: this.props.siderCollapsed || false
    };
     static childContextTypes = {
      siderHook: PropTypes.object,
    };
     getChildContext() {
      return {
        siderHook: {
          addSider(id) {
            this.setState({
              siders: [...this.state.siders, id],
            });
          },
          removeSider(id) {
            this.setState({
              siders: this.state.siders.filter(currentId => currentId !== id),
            });
          },
        },
      };
    }
      toggleSider() {
      const { siderCollapsed } = this.state;
      this.setState({
        siderCollapsed: !siderCollapsed,
      });
    } */
    value: function render() {
      var _classNames;

      var _this$props3 = this.props,
          className = _this$props3.className,
          children = _this$props3.children,
          hasSider = _this$props3.hasSider,
          open = _this$props3.open,
          rowtype = _this$props3.rowtype; // const { siders } = this.state;

      var classes = classNames(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-has-sider"), hasSider), _defineProperty(_classNames, "".concat(prefixCls, "--open"), open), _classNames), className);
      return /*#__PURE__*/React.createElement(Row, {
        type: rowtype,
        className: classes
      }, children);
    }
  }]);

  return Layout;
}(React.Component);

_defineProperty(Layout, "defaultProps", {
  hasSider: false,
  open: false,
  rowtype: undefined,
  onToggle: function onToggle(e) {}
});

_defineProperty(Layout, "propTypes", {
  hasSider: PropTypes.bool,
  open: PropTypes.bool,
  onToggle: PropTypes.func,
  rowtype: PropTypes.string
});

Layout.childContextTypes = {
  layout: PropTypes.instanceOf(Layout)
};

var LayoutSidebar = function LayoutSidebar(props) {
  var children = props.children,
      className = props.className;
  var classes = classNames("".concat(prefixCls, "-sider"), {}, className);
  return /*#__PURE__*/React.createElement(Col, {
    className: classes
  }, children);
};

var LayoutContent = function LayoutContent(props, _ref) {
  var layout = _ref.layout;
  var children = props.children,
      className = props.className;
  var classes = classNames("".concat(prefixCls, "-content"), {}, className);
  return /*#__PURE__*/React.createElement(Col, {
    className: classes
  }, children);
};

LayoutContent.contextTypes = {
  layout: PropTypes.object
}; // export default Layout;

export { Layout, LayoutSidebar, LayoutContent };